import { useTheme, THEME_MODES } from '@shared/context/ThemeContext';
import { IconSun, IconMoon, IconDeviceDesktop } from '@tabler/icons-react';
import classNames from 'classnames';
import s from './theme-switcher.module.scss';

const OPTIONS = [
	{ value: THEME_MODES.SYSTEM, label: 'Системная', Icon: IconDeviceDesktop },
	{ value: THEME_MODES.LIGHT, label: 'Светлая', Icon: IconSun },
	{ value: THEME_MODES.DARK, label: 'Тёмная', Icon: IconMoon },
];

export const ThemeSwitcher = () => {
	const { theme, setTheme, isForced } = useTheme();

	return (
		<div className={s.switcher} role="radiogroup" aria-label="Тема оформления">
			{OPTIONS.map(({ value, label, Icon }) => (
				<button
					key={value}
					type="button"
					role="radio"
					aria-checked={theme === value}
					className={classNames(s.option, theme === value && s.active)}
					onClick={() => setTheme(value)}
					disabled={isForced}
				>
					<Icon size={18} />
					<span>{label}</span>
				</button>
			))}
		</div>
	);
};
